import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css"
import { FaMapMarker } from 'react-icons/fa';
import { FaSearch } from 'react-icons/fa';
import { FaShare } from 'react-icons/fa';
import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import Icon from '../icon';
import {Form, Input, FormGroup, Container, Label} from 'reactstrap';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Modal from 'react-responsive-modal';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import ReactExport from "react-export-excel";
import moment from 'moment';
import { Link , Redirect } from 'react-router-dom';

import matchpointlogo from '../assets/images/matchpointlogo.png';
import calender from '../assets/images/calender.png';
import logout from '../assets/images/logout.png';
import orange from '../assets/images/orange.png';
import '../main.css'
import { render } from "react-dom";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Loader from 'react-loader-spinner'
import Dialog from 'react-dialog'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { CSVLink, CSVDownload } from "react-csv";
import Background from '../assets/images/New_Project.png';
import ReactTooltip from "react-tooltip";
import "react-table/react-table.css";
import axios from "axios";
import Flag from "react-flags";
import "antd/dist/antd.css";
import { Table, Tooltip } from "antd";

import Timekeeper from 'react-timekeeper';
import Grid from '@material-ui/core/Grid';
import host from './ipaddress';
import { counter } from '@fortawesome/fontawesome-svg-core';
import VirtualizedMultiSelect from './VirtualizedMultiSelect';
import Common_function from './Common_function';
import { osName,osVersion,browserName,deviceType } from 'react-device-detect';
import ApiUrlCall from './Api/apiurl';
import AuthService from '../Config/AuthService';



const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

var gl_requestcode;
var gl_requesttype;
var gl_orderno;
var gl_list = [];
var gl_req_data = []
var timercounter = 0;

class TopParkingLoc extends Component{
  constructor(props){
    super(props);

    const token = localStorage.getItem("token")
    let loggedIn = true
    if(token == null){
      loggedIn = false
    }
    this.state={
      loggedIn,

      value: '',
      date: new Date(),
      host : host ,
      totalCount:'',
      startTime: "12:00 am",
      showStartTime: false,
      showEndTime: false,
      endTime: "11:59 pm",
      sendEndTime: "23:59",
      sendStartTime: "00:00",
      startDate: new Date(),
      endDate: new Date(),
      checkebox_value: [],
      user1 : localStorage.getItem("username"),
      userGroups: localStorage.getItem('user_groups'),

      lonNoList : [],
      is_checked: true,
      //radius : 0,
      options : [],
      tableData : [],
      isDisabled : false,

    }
    this.onChange = this.onChange.bind(this);
    this.postData = this.postData.bind(this);
    this.showPassword = this.showPassword.bind(this);    
  }

componentDidMount(){
  this.showLosNumber()
}

onRowClick = (state, rowInfo, instance) => {
  return {
    onClick: (e, handleOriginal) => {
      if (handleOriginal) {
        handleOriginal();
      }
      $(this).remove();
    }
  };
};

postData(e) {
  e.preventDefault()
    var inputs = document.getElementsByClassName('mpassword');
    let reqdata = {}
    reqdata['mobile_number']=localStorage.getItem('mobile_number')
    Array.prototype.forEach.call(inputs, function(x) {
      reqdata[x.name] = x.value
    })
    $("#loading-image").show();
    $(".loading-icon").show();
    let formdata = reqdata
    const forgeturl = this.state.host + '/v1/mpgps/landerDashboard/change_password/'
    axios.post(forgeturl, formdata, {
      headers: {
        'Authorization': localStorage.getItem('token'),
      },
    })
      .then(response => {
        $("#loading-image").hide();
        $(".loading-icon").hide();
        if (response.data.is_success) {
          document.getElementById('resetpass').disabled = true;        
          document.getElementById('lbl_err').innerHTML = response.data.data.message;
          document.getElementById('lbl_err').style.color = 'green';
          setTimeout(() => {
              //this.logoutHandler()
            },2000);

        } else {
          document.getElementById('lbl_err').innerHTML = response.data.response_message;
          document.getElementById('lbl_err').style.color = 'red';
        }
      })
      .catch(error => {
        console.log(error)  
        $("#loading-image").hide();
        $(".loading-icon").hide();      
        if (document.getElementById('lbl_err').innerHTML !== null) {
          document.getElementById('lbl_err').innerHTML = error;
        }
      }) 
}



onChange(e) {

  if (["new_password","confirm_password"].includes(e.target.id))
  {
    if (document.getElementById('new_password').value ==
              document.getElementById('confirm_password').value) {
          document.getElementById('resetpass').disabled = false;
          document.getElementById('lbl_err').innerHTML = "Matched";
          document.getElementById('lbl_err').style.color = 'green';
        } else {          
          document.getElementById('lbl_err').innerHTML = "Not Matched"
          document.getElementById('lbl_err').style.color = 'red';
          document.getElementById('resetpass').disabled = true;
      }
  }
}


showLosNumber = () =>{
  $.ajax({
    url: this.state.host+'/v1/mpgps/landerDashboard/get_cars24_data/',
    dataType: 'json',
    type:'post',
    data:{},
    beforeSend: function(request) {
        request.setRequestHeader("authorization", localStorage.getItem("token"));
        request.setRequestHeader('api-head', JSON.stringify({"user_id":localStorage.getItem("user"),"mobile_number":localStorage.getItem("mobile_number"),"username":localStorage.getItem("username")}));
        $("#loading-image").show();
        $(".loading-icon").show();
      },
    success: function(data) {
      // Transform data to options array in one pass
      const options = data.data.map(item => ({
        label: item.lan_no,
        value: item.serial_no
      }));

      this.setState({
        lonNoList: data.data,
        totalCount: data.total_count,
        options: options
      }, () => {
        $("#loading-image").hide();
        $(".loading-icon").hide();
      });
    }.bind(this),
    error: function(xhr, status, err) {
      console.error(this.props.url, status, err.toString());
      console.log('fail');
      // alert("Internal Server Error");
      $("#loading-image").hide();
      $(".loading-icon").hide();
      if(err.toString() == "Forbidden"){
       //this.logoutHandler()
      }
    }.bind(this)
  });
}


logoutHandler =(e) =>{
  var user_id = localStorage.getItem("user")
  var sha256 = require('js-sha256');
  var userid_enc = sha256(user_id);

  var active_session = {
    start_time : Common_function.ServerDateTime(localStorage.getItem("cache focus date")),
    end_time: Common_function.ServerDateTime(new Date())
  }
   console.log(active_session ,"logout time detail")
  var device_detail = [{
   event_id : 1,
  unique_id : userid_enc,
    os_version : osVersion,
    model_name: osName,
    value : active_session,user_id:user_id,
  
  }]
  
  const analytics_details = {
    data : device_detail , source : 2
  };

  
 JSON.stringify(analytics_details)

//  console.log("hello..", analytics_details)
        
  ApiUrlCall.send_analytics(analytics_details).then(response => {
     
    if (response.status === 200) {
      return

    }
  }
  )
  // Stop session services
  AuthService.stopTokenRefresh();
  AuthService.stopHeartbeat();

  // End session and logout on server
  AuthService.endSession().catch(err => console.log('End session error:', err));
  AuthService.logOut().catch(err => console.log('Logout error:', err));

  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");
  localStorage.removeItem("mobile_number");
  localStorage.removeItem("username");
  localStorage.setItem('cache focus date','')


  gl_requestcode="";
  gl_requesttype="";
  gl_orderno="";
  gl_list = [];
  gl_req_data = []
  timercounter = 0;
  setTimeout(function(){
    window.location.reload()
  }, 1000);  
}

showPassword = (e) => {
  var inputs = document.getElementsByClassName('mpassword');
  Array.prototype.forEach.call(inputs, function(x) {
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  })
}


onChange2 = (e) =>{
  this.setState({
    checkebox_value: e
  })
} 


createServerDateTime = (date, time) => {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if(month <= 9){
    month = '0'+month
  }
  if(day <= 9){
    day = '0'+day
  }
  var datetime = year + "-" + month + "-" + day + " " + time + ":" + "00"
  return datetime
}

dateValidation(start, end) {
  var start = new Date(start);
  var end = new Date(end);  
  if (start > end) {
    return false
  } else {
    return true
  }
}

sendDataToGenerateReport = (e) =>{
  const {endDate,startDate,sendEndTime,sendStartTime} = this.state
  if (this.state.startDate == null){
      alert("Please select start date.")
      return
  }else{
      var start_date_time = this.createServerDateTime(startDate,sendStartTime)
    }

  
  if(this.state.checkebox_value.length == 0){
    alert("Please select los number.")
    return
  }
  this.hideAllDropDown()
  const obj = {}
    this.state.checkebox_value.map(data =>{
        obj[data.value] = data.label
    })
    var data = JSON.stringify({"date" : start_date_time,
    "serial_lan_list": obj,})

    $.ajax({
      url: this.state.host+'/v1/mpgps/landerDashboard/top_parking_loc_report/',
      dataType: 'json',
      type:'post',
      data:data,
      beforeSend: function(request) {
          request.setRequestHeader("authorization", localStorage.getItem("token"));
          request.setRequestHeader('api-head', JSON.stringify({"user_id":localStorage.getItem("user"),"mobile_number":localStorage.getItem("mobile_number")}));
          $("#loading-image").show();
          $(".loading-icon").show();
        },
      success: function(data) {
        $("#loading-image").hide();
        $(".loading-icon").hide();
        this.setState({
          tableData : data.data
        },() =>{
          if(this.state.tableData.length == 0){
              alert("No data found.")
          }
        })
          
      }.bind(this),
      error: function(xhr, status, err) {
        console.error(this.props.url, status, err.toString());
        console.log('fail');
        // alert("Internal Server Error");
        $("#loading-image").hide();
        $(".loading-icon").hide();
        if(err.toString() == "Forbidden"){
         //this.logoutHandler()
        }
      }.bind(this)
    });


}

convertTime =(sec) =>{
  var hours = Math.floor(sec/3600);
  (hours >= 1) ? sec = sec - (hours*3600) : hours = '0';
  //(hours >= 10 && hours <= 1) ? sec = sec - (hours*3600) : hours = '0'+hours;
  var min = Math.floor(sec/60);
  (min >= 1) ? sec = sec - (min*60) : min = '00';
  (sec < 1) ? sec='00' : void 0;

  (min.toString().length == 1) ? min = '0'+min : void 0;    
  (sec.toString().length == 1) ? sec = '0'+sec : void 0; 

  return hours+' Hr:'+min+' Min :'+sec+" Sec";
}


////////////////////////////////////////////////////////

showStartDate = (e) => {
  $(e.currentTarget).next().slideToggle(200, "swing")
}

showStartDate = (e) => {
  $(e.currentTarget).next().slideToggle(200, "swing")
  $('#end_date_cal').slideUp()
  this.setState({
    showStartTime: false,
    showEndTime: false,
  })
}

StartdateClicked = date => {
  var isoStartDate = date
  this.setState({ startDate: isoStartDate })
  $('#start_date_cal').slideUp(200)
}

dateFormate = (rdate) => {
  var date = new Date(rdate);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if (day < 10) {
    day = '0' + day;
  }
  if (month < 10) {
    month = '0' + month;
  }
  var convertDate = day + '/' + month + '/' + year
  return convertDate
}

hideAllDropDown = () => {
  $('#start_date_cal').hide()
  this.setState({
    showStartTime: false,
  })
}

/////////////////////////////////////////////////////////

render(){
  var minDate = new Date(); 
  minDate.setDate(minDate.getDate() - 180);
  if(this.state.loggedIn === false){
      return <Redirect to="/" />
    }

  const headers = [
    { label: "Sr No.", key: "sr_no" },
    { label: "Order No.", key: "lan_no" },
    { label: "Serial No.", key: "serial_no" },
    { label: "Location", key: "address" },
    { label: "Start Time", key: "start_time" },
    { label: "End Time", key: "end_time" },
    { label: "Parking Duration", key: "prk_dur" },
    { label: "Rank", key: "rank" },
  ];

  const columns=[
  {
    Header: <Tooltip title="Sr No.">Sr No.</Tooltip>,
    accessor: "sr_no",
    style:{
      textAlign:"center"
    },
    Cell: (row) => { return <div>{row.index+1}</div>},
    width:100,
    minWidth:100,
    maxWidth:100
  },
  {
    Header: <Tooltip title="Order No.">Los No.</Tooltip>,
    accessor: "lan_no",
    style:{
      textAlign:"center"
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>},
    width:100,
    minWidth:100,
    maxWidth:100,
  },
  {
    Header: <Tooltip title="Order No.">Serial No.</Tooltip>,
    accessor: "serial_no",
    style:{
      textAlign:"center"
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>},
    width:100,
    minWidth:100,
    maxWidth:100,
  },    
  {
    Header: <Tooltip title="Location">Location</Tooltip>,
    accessor: "address",
    sortable:true,
    style:{
      textAlign:"center",
      // 'whiteSpace': 'unset'
    },
    Cell: row => {
      const value = row.value; // Extract the value for readability
      if (value === 'Service Expired') {
        return (
          <div>
            <span title={value} style={{ color: 'red' }}>{value}</span>
          </div>
        );
      } else {
        return (
          <div>
            <span title={value}>{value}</span>
          </div>
        );
      }
    },
    width:600,
  },
  {
    Header: <Tooltip title="Lattitude & Longitude">Lattitude & Longitude</Tooltip>,
    accessor: "lat_log",
    sortable:true,
    style:{
      textAlign:"center",
      // 'whiteSpace': 'unset'
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>},
  },
  {
    Header: <Tooltip title="Start Time">Start Time</Tooltip>,
    accessor: "start_time",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  {
    Header: <Tooltip title="End Time">End Time</Tooltip>,
    accessor: "end_time",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  {
    Header: <Tooltip title="Parking Duration">Parking Duration</Tooltip>,
    accessor: "prk_dur",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  {
    Header: <Tooltip title="Parking Rank">Rank</Tooltip>,
    accessor: "rank",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  ]



  return (
    <div>
      {/*header component start*/}
      <div className="navbar navbar-default">
        <div className="container-fluid pl-0">
              <div className="navbar-header">
                <a className="header-logo">
                <Link to="/lenderdashboard"><img src={matchpointlogo} alt="matchpointlogo" width="300" className="logo"/></Link>
                </a>
              </div>
          <div className="nav navbar-nav navbar-right">
          <div className=" list-inline mb-0">
          <div id="profile_menu" className="list-inline-item fs-21 fc-red text-capitalize border-right cursor-pointer usernamemenu "
          onMouseOver={(e) => {
            //$("#profile_menu").toggle()
          }}
          onMouseLeave={(e) => {
            //$("#profile_menu").toggle()
          }}
          >
            Welcome, {this.state.user1}<span className="color-orange">
            </span>
            {/* <ul>
                <li><a href="#" data-toggle="modal" data-target="#resetPassword" >Change Password</a></li>
            </ul>  */}

          <ul>
          
          {this.state.userGroups[0] === '5' && this.state.userGroups[2] === '7' ? (
            <li>
               <Link to="/Api_integration" style={{ color: 'black', textDecoration: 'none',  }} className="custom-link" >
                 
                 <span style={{ textDecoration: 'none' }} >  Api Integration </span>

               </Link>
          </li> ) : null}
        
        </ul>

          </div>
          
          <div className="list-inline-item">
              <a onClick={e=>this.logoutHandler(e)} className="cursor-pointer">
                <img src={logout} alt="logout-logo" width="30"/>
              </a>
          </div>
          </div>
          </div>
      </div>
    </div>
    {/*header component end*/}

      {/* Range component start*/}
      <div className="container-fluid pt-35 red1">
      <Grid spacing={2} container >
        <Grid item xs>
          <p className="period-text1">Los No</p>
          <div className="gray-shadow" style = {{marginLeft : "13px",width : '50%'}}>
            <div className="custom-serach-input1">
              <VirtualizedMultiSelect
              options={this.state.options}
              value={this.state.checkebox_value}
              onChange={this.onChange2}
              placeholder="Select Los No"
              isDisabled={this.state.isDisabled}
              maxSelection={50}
              />
            </div>
          </div>  
        </Grid>

          <Grid item xs>
              <p className="period-text1" >Date</p>
              <div className="gray-shadow" style = {{width : '50%'}}> 
                <div className="input_div" onClick={this.showStartDate}>
                  <input type="text" placeholder= "Date" id="start_date" disabled value={this.dateFormate(this.state.startDate)} className="journey_input"></input>
                  <img src={calender} className="calender_icon"></img>
                </div>
                <div className="calendar_parent" id="start_date_cal">
                  <Calendar
                    selectRange={false}
                    onChange={this.StartdateClicked}
                    value={this.state.startDate}
                    maxDate={this.state.date}
                    minDate={minDate}
                  />
                </div>
              </div>
              
          </Grid>

        <Grid item xs>
            <p className="period-text1"></p>
            <button type="submit" id="submit_id"   style={{ marginTop: "25px",marginLeft : "20px" }} className="btn btn-dark submit-btn" onClick={this.sendDataToGenerateReport}>Generate Report</button>
        </Grid>

        <Grid item xs>
            <p className="period-text1"></p>
            <ExcelFile element={<button className="btn btn-md btn-dark export-btn"  style={{ marginTop: "25px" }} onClick={this.ExcelFileLoader}>Export Excel Report</button>}>
                <ExcelSheet data={this.state.tableData} name="Reports">
                  <ExcelColumn label='Sr No.' value="sr_no"/>
                  <ExcelColumn label='Los No.' value="lan_no"/>
                  <ExcelColumn label='Serial No.' value="serial_no"/>
                  <ExcelColumn label='Location' value="address"/>
                  <ExcelColumn label='Lattitude & Longitude' value="lat_log"/>
                  <ExcelColumn label='Start Time' value="start_time"/>
                  <ExcelColumn label='End Time' value="end_time"/>
                  <ExcelColumn label='Parking Duration' value="prk_dur"/>
                  <ExcelColumn label='Rank' value="rank"/>
                </ExcelSheet>
            </ExcelFile>
        </Grid>
      </Grid>
        <br/>
        </div>
        {/*Range component end */}

        {/* Dashboardtable component start */}
          <div className="red2">
            <div className="plr-20">
              <ReactTable columns={columns}
                  getTdProps={this.onRowClick}
                  ref={r => (this.reactTable = r)}
                  data={this.state.tableData}
                  showPagination={true}
                  pageSizeOptions = {[1000,2000]}
                  defaultPageSize={1000}
                  style={{
                    maxHeight: "630px" // This will force the table body to overflow and scroll, since there is not enough room
                  }}>
                </ReactTable>
              <div className="loading-icon" id="myDiv">
                <img id="loading-image" / >
              </div>
            </div>
          </div>
        {/* Dashboardtable component end */}

        {/* Reset Password model window start here */}
        <div class="modal fade" id="resetPassword" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close closebutton" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                <h4 class="modal-title">Change Your Account Password</h4>
              </div>
              <form href="" method="post" >
                <div class="modal-body">
                  <div class="form-group">
                    {/* <label for="accountEmail">Account Email</label> */}
                    <span class="help-block">Old Password.</span>
                    <input  id="old_password" type="password" onChange={this.onChange} class="form-control mpassword" required="required" name="old_password" />
                    <span  class="help-block">New Password.</span>
                    <input id="new_password" type="password" minlength="8" onChange={this.onChange} class="form-control mpassword" required="required" name="new_password" />
                    <span class="help-block ">Confirm Password.</span>
                    <input id="confirm_password" type="password" minlength="8" onChange={this.onChange} class="form-control mpassword" required="required" name="confirm_password" />
                  </div>
                  <input type="checkbox" onChange={this.showPassword} /> Show Password
                  <br/>
                  <label for="error-msg" id="lbl_err"></label>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default btn-sm btn-icon" data-dismiss="modal">Cancel</button>
                  <button type="input" id="resetpass" onClick={this.postData} name="submit" value="resetPass" class="btn btn-success btn-sm btn-icon"> Change Password</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      {/* Reset Password model window end here */}
                          
    </div>
        )
    }
}
export default TopParkingLoc
